import { Component, OnInit, ViewChild } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { Cxcenctmpamortiza } from "../cxcinterfaces/cxcenctmpamortiza";
import { Cxcdettmpamortiza } from "../cxcinterfaces/cxcdettmpamortiza";
import { CxctmpamortizacionService } from "../cxcservicios/cxctmpamortizacion.service";

import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { DatePipe } from '@angular/common';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined } from 'util';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { Usuario } from 'src/app/usuario';


@Component({
  selector: 'app-cxctmpamortizacion',
  templateUrl: './cxctmpamortizacion.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class CxctmpamortizacionComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  index


  indicador: any;
  permisoTmpcotiza: SegMaePermiso;
  lblclinombre
  lblgarnombre
  lblestado
  /*busquedas*/
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  consulta: string;
  displayDialogBusquedaFast: boolean;

  public frameworkComponents;
  rowStyle;
  defaultCxctmpamortiza;
  rowSelection = 'multiple';

  spin
  boolfac

  displayDialogDocumentos = false;
  displayDialogReportes: boolean;
  displayAsiContable: boolean;

  auxreporte: number = 0;

  strNombreForma: string;

  asiento: any;
  auxiliar1: number;

  displayrefi

  dettmpamortizaSelected: Cxcdettmpamortiza
  abonocapital

  columnDefsCxctmpamortiza = [
    {//0
      headerName: 'Fecha', field: 'FECHA', cellEditor: 'cellPrueba', width: 90, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//1
      headerName: 'No. Cuota', field: 'NO_CUOTA', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' }, width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//2
      headerName: 'Días', field: 'DIAS', cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//3
      headerName: 'Cuota', field: 'VAL_CUOTA', cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//4
      headerName: 'Pago Extra', field: 'PAGO_EXTRA', cellEditor: 'cellPrueba', width: 150, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//5
      headerName: 'Pago Total', field: 'PAGO_TOTAL', cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//6
      headerName: 'Capital', field: 'CAPITAL', cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//7
      headerName: 'Interés', field: 'INTERES', cellEditor: 'cellPrueba', width: 80, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//8
      headerName: 'Saldo Capital', field: 'SALDO_CAPITAL', cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//9
      headerName: 'Observación', field: 'OBSERVACION', cellEditor: 'cellPrueba', width: 130, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//10
      headerName: 'Factor', field: 'FACTOR', cellEditor: 'cellPrueba', width: 130, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//11
      headerName: 'Producto Acum', field: 'PRODUCTO_ACUM', cellEditor: 'cellPrueba', width: 130, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//12
      headerName: 'N Nominal', field: 'N_NOMINAL', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      onCellDoubleClicked: (params) => {
        this.abrirrefinaciamiento(params.data);
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: true
        }
      }
    },
    {//13
      headerName: 'Facturas', field: 'TRNCOBRO_NRODOC', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {//14
      headerName: 'CIs', field: 'CIS', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {//15
      headerName: 'Enc. Cuota Origen', field: 'ENCCUO_CODIGO', cellEditor: 'cellPrueba', width: 195, editable: (params) => {
        return false;
      },
    },

  ]
  constructor(
    public init: NuevoComponentService, public cxctmpamortizacionService: CxctmpamortizacionService,
    private busquedaSer: InvbusquedaService, private datePipe: DatePipe, private permisosService: PermisosService,
    private messageService: MessageService, private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    private utilitariosService: UtilitariosService, private confIniciales: ConfInicialesService, public usuario: Usuario,

  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultCxctmpamortiza = {
      width: 100,
      objeto: 'cxctmpamortiza',
      editable: true
    };
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.index = 0;
    this.lblclinombre = '';
    this.lblgarnombre = ''
    this.lblestado=''
    this.spin = false
    this.displayrefi = false
    this.cxctmpamortizacionService.enctmpamortiza[this.indicador] = {};
    this.cxctmpamortizacionService.dettmpamortiza = [];
    this.dettmpamortizaSelected = {}
    this.abonocapital = Number(0).toFixed(2)
    await this.getPermisos()
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoTmpcotiza = data[0];
        } else {
          this.permisoTmpcotiza = null;
        }
      } else {
        this.permisoTmpcotiza = null;
      }
    } catch (e) {
      this.permisoTmpcotiza = null;
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async manejarSenales(valor) {

    if (valor === 'Nuevo') {
      if (this.permisoTmpcotiza.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoTmpcotiza.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada'
          });
        }
      }
    }
    if (valor === 'Guardar') {
      if (this.permisoTmpcotiza.PERTODO === 1) {
        this.validarGuardar();
      } else {
        if (this.permisoTmpcotiza.PERINSERCION === 1) {
          this.validarGuardar();
        } else {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada'
          });
        }
      }
    }
    if (valor === 'Borrar') {
      if (this.permisoTmpcotiza.PERTODO === 1) {
        const trndocnnum = this.cxctmpamortizacionService.dettmpamortiza.filter(x => isNullOrUndefined(x.TRNCOBRO_NRODOC) === false
          && x.TRNCOBRO_NRODOC !== '' && x.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador]
            .ENCCUOTA_CODIGO)

        const data = await this.cxctmpamortizacionService.getdetdocumento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
        if (trndocnnum.length > 0) {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'No se puede eliminar todo el documento porque ya se generaron las facturas, debe reversar primero'
          });
          return;
        }
        if (data[0].NUMERO > 0) {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'info',
            summary: 'Información',
            detail: 'Las facturas ya han sido generadas en el sistema, debe reversar primero'
          });
          return
        }
        if ( this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D') {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'info',
            summary: 'Información',
            detail: 'No se puede eliminar una amortización desactivada'
          });
          return
        }
        this.borrar();
      } else {
        if (this.permisoTmpcotiza.PERELIMACION === 1) {

          const trndocnnum = this.cxctmpamortizacionService.dettmpamortiza.filter(x => isNullOrUndefined(x.TRNCOBRO_NRODOC) === false
            && x.TRNCOBRO_NRODOC !== '' && x.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador]
              .ENCCUOTA_CODIGO)

          const data = await this.cxctmpamortizacionService.getdetdocumento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
          if (trndocnnum.length > 0) {
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'error',
              summary: 'Información',
              detail: 'No se puede eliminar todo el documento porque ya se generaron las facturas, debe reversar primero'
            });
            return;
          }
          if (data[0].NUMERO > 0) {
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'info',
              summary: 'Información',
              detail: 'Las facturas ya han sido generadas en el sistema, debe reversar primero'
            });
            return
          }
          if ( this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D') {
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'info',
              summary: 'Información',
              detail: 'No se puede eliminar una amortización desactivada'
            });
            return
          }
          this.borrar();
        } else {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }
      }
    }
    if (valor === 'Visto') {
      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== ''
        && isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO) === false
        && this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D'
      ) {
        return
      }
      this.generaramortizacion()
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Generar') {
      const trndocnnum = this.cxctmpamortizacionService.dettmpamortiza.filter(x => isNullOrUndefined(x.TRNCOBRO_NRODOC) === false
        && x.TRNCOBRO_NRODOC !== '' && x.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador]
          .ENCCUOTA_CODIGO)
      const data = await this.cxctmpamortizacionService.getdetdocumento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)

      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO === ''
        || isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
      ) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'Debe guardar primero la amortización para poder generar las facturas'
        });
        return
      }
      if (trndocnnum.length > 0) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'Las facturas ya han sido generadas'
        });
        return
      }
      if (data[0].NUMERO > 0) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'Las facturas ya han sido generadas en el sistema'
        });
        return
      }
      this.generarfacturas()
    }
    if (valor === 'Buscar') {
      this.buscar();
    }
    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }
    if (valor === 'Almacenardoc') {
      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== ''
        && isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO) === false
      ) {
        const usu = await this.confIniciales.obtenerPermisoUsuario(this.usuario.identificacion);
        if (usu[0].USU_ALMACENARDOC === 1 || usu[0].USU_VISUALIZARDOC === 1) {
          this.displayDialogDocumentos = true;
        } else {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'info',
            summary: 'Información',
            detail: 'No tiene los permisos necesarios. Consulte con el Administrador del Sistema'
          });
        }
      }
    }
    if (valor === 'Reversar') {
      if ( this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'No se puede reversar una amortización desactivada'
        });
        return
      }
      this.reversarfacturas();
    }
    if (valor === 'Asiento') {
      if ( this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D') {
        return
      }
      const trndocnnum = this.cxctmpamortizacionService.dettmpamortiza.filter(x => isNullOrUndefined(x.TRNCOBRO_NRODOC) === false
        && x.TRNCOBRO_NRODOC !== '' && x.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador]
          .ENCCUOTA_CODIGO)
      const data = await this.cxctmpamortizacionService.getdetdocumento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)

      // if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO === ''
      //   || isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
      // ) {
      //   this.messageService.add({
      //     key: 'cxctmpamortiza',
      //     severity: 'info',
      //     summary: 'Información',
      //     detail: 'Debe guardar primero la amortización para poder generar el asiento'
      //   });
      //   return
      // }
      if (trndocnnum.length === 0) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'Deebe generar primero las facturas'
        });
        return
      }
      if (data[0].NUMERO === 0) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'info',
          summary: 'Información',
          detail: 'Las facturas aún no han sido generadas en el sistema, debe generarlas primero'
        });
        return
      }
      this.generarAsiento();
    }
    if (valor === 'AsientoVer') {
      this.verAsiento();
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }

  }
  async generarAsiento() {
    try {
      this.spin = true
      await this.cxctmpamortizacionService.generarasiento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'success',
        summary: 'Información',
        detail: 'El asiento se generó con éxito'
      });
      await this.encontrarregistro(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'info',
        summary: 'Información',
        detail: 'Hubo un error al generar el asiento'
      });
      console.log(error)
      return
    }
  }
  verAsiento() {
    this.asiento = this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ASI_NRO;
    if (this.asiento === null || this.asiento === undefined || this.asiento === '') {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'No ha generado el Asiento Contable'
      });
    } else {
      this.auxiliar1++;
      // this.displayDialogAsiento = true;
      this.displayAsiContable = true;
    }
  }
  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
  reversarfacturas() {
    this.confirmationService.confirm({
      message: 'Está seguro de reversar las facturas generadas?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxctmpamortizaConfirmacion',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {
          this.spin = true
          let numero = this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO

          const data = await this.cxctmpamortizacionService.reversarfacturas(numero)
          let numreg = data[0][':B1']
          if (numreg === 1) {
            await this.auditoriagral.registrarAuditoria('VEN_ENCCUOTA',
              numero + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO + '/BOTON-REVERSAR-FACTURAS', 'E',
              '', '01', '', '', '', '').toPromise();
            await this.cancelar()
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'success',
              summary: 'Información',
              detail: 'El proceso para reversar las facturas generadas, terminó con éxito'
            });
            this.spin = false
          } else {
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'error',
              summary: 'Error',
              detail: 'No se pueden reversar las facturas generadas, porque ya tienen pagos registrados'
            });
            this.spin = false
          }

        } catch (error) {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un error durante el proceso para reversar las facturas generadas '
          });
          this.spin = false
          console.log(error);
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  borrar() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'cxctmpamortizaConfirmacion',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: async () => {
        this.confirmationService.close();
        try {

          let numero = this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO

          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO = ''
          await this.cxctmpamortizacionService.borrarRegistro(numero, this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CUOORIGEN)
          await this.auditoriagral.registrarAuditoria('VEN_ENCCUOTA',
            numero + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO, 'E',
            '', '01', '', '', '', '').toPromise();
          await this.cancelar()
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'success',
            summary: 'Información',
            detail: 'El registro se eliminó de forma correcta'
          });
        } catch (error) {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'Ocurrió un erro durante la eliminación '
          });
          console.log(error);
        }
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  recibirSenalesDocumentos(valor) {
    if (valor === true) {
      this.displayDialogDocumentos = false;
    }
  }
  cerrarReportes() {
    this.displayDialogReportes = false;
  }
  buscar() {
    this.opcionbusqueda = 'BUSQUEDAENCCUOTA';
    this.types = [
      { label: 'NÚMERO', value: 'ENCFAC_NUMERO' },
      { label: 'FECHA_AMORTIZACION', value: 'ENCCUO_FECHA' },
      { label: 'NUM. DOC', value: 'ENCCUO_CODIGO' },
      { label: 'COD_CLIENTE', value: 'CLI_CODIGO' },
      { label: 'NOMBRE_CLIENTE', value: 'CLI_NOMBRE' },
      { label: 'COD_GARANTE', value: 'GAR_ID' },
      { label: 'NOMBRE_GARANTE', value: 'GAR_NOMBRE' },

    ];
    this.busquedacampos = ['', '', '', '', '', '', ''];

    this.consulta = 'A.*, VEN_FNC_NOMBRE_CLIENTE(CLI_CODIGO,\'01\') AS CLI_NOMBRE, '
      + ' CXC_FNC_NOMBRE_GARANTE(GAR_ID,\'01\') AS GAR_NOMBRE';

    this.tabla = 'VEN_ENCCUOTA A';
    this.where = 'ENCCUO_CODIGO' + ' IS NOT NULL order by ENCCUO_FECHA desc ';

    //this.spin = true;
    this.busquedaSer.busquedaVenEncCUOTA().subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.arregloCons.map((registro) => {
        if (registro.ENCCUO_FECHA !== null) {
          registro.ENCCUO_FECHA = this.datePipe.transform(registro.ENCCUO_FECHA, 'dd/MM/yyyy');
        } else {
          registro.ENCCUO_FECHA = '';
        }

      });
      //this.spin = false;
      this.displayDialogBusquedaFast = true;
    });
  }
  async validarGuardar() {
    try {
      this.spin = true
      const trndocnnum = this.cxctmpamortizacionService.dettmpamortiza.filter(x => isNullOrUndefined(x.TRNCOBRO_NRODOC) === false
        && x.TRNCOBRO_NRODOC !== '' && x.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador]
          .ENCCUOTA_CODIGO)
      const data = await this.cxctmpamortizacionService.getdetdocumento(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID !== '' &&
        isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID) === false
      ) {
        const data = await this.cxctmpamortizacionService.getgarante(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID)
        if (data[0].NUMERO === 0) {
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'error',
            summary: 'Información',
            detail: 'El garante no existe'
          });
          this.spin = false
          return
        }
      }

      if (trndocnnum.length > 0 && this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Las facturas ya han sido generadas, no puede editar el documento'
        });
        this.spin = false
        return
      }
      if (data[0].NUMERO > 0 && this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Las facturas ya han sido generadas en el sistema y ya no se puede editar el documento'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un factura'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un factura para que el campo cliente se llene correctamente'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo Tasa Anual no debe estar vacío'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo plazo Original no debe estar vacío'
        });
        this.spin = false
        return
      }
      if (this.cxctmpamortizacionService.dettmpamortiza.length === 0) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe generar la amortización previa primero'
        });
        this.spin = false
        return
      }
      await this.finalgeneracuotas()

    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar la información para guardar las cuotas'
      });
      this.spin = false
      console.log(error)
    }
  }
  async generarfacturas() {
    try {
      this.spin = true
      await this.cxctmpamortizacionService.generarfacturas(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO);
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'success',
        summary: 'Información',
        detail: 'Éxito al generar las facturas'
      });
      await this.auditoriagral.registrarAuditoria('VEN_DETCUOTA',
        'Código:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO
        + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO
        + '/BOTON-GENERAR-FACTURAS', 'I',
        '', '01', '', '', '', '').toPromise();
      this.encontrarregistro(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
      this.spin = false
    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al generar las facturas'
      });
      this.spin = false

    }
  }
  async finalgeneracuotas() {
    try {
      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI.toString().includes('-')) {
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI = this.datePipe.transform(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI, 'dd/MM/yyyy')
      }

      const data = await this.cxctmpamortizacionService.insertarenccuota(this.cxctmpamortizacionService.enctmpamortiza[this.indicador]);
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== '') {
            await this.auditoriagral.registrarAuditoria('VEN_ENCCUOTA',
              'Código:' + iterator.ENCCUOTA_CODIGO + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO
              + '/Garante:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID, 'A',
              '', '01', '', '', '', '').toPromise();
          } else {
            await this.auditoriagral.registrarAuditoria('VEN_ENCCUOTA',
              'Código:' + iterator.ENCCUOTA_CODIGO + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO
              + '/Garante:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID, 'I',
              '', '01', '', '', '', '').toPromise();
          }


          for (const item of this.cxctmpamortizacionService.dettmpamortiza) {
            if (item.FECHA.toString().includes('-')) {
              item.FECHA = this.datePipe.transform(item.FECHA, 'dd/MM/yyyy')
            }
            item.VAL_CUOTA = Number(item.VAL_CUOTA);
            item.NO_CUOTA = Number(item.NO_CUOTA);
            item.DIAS = Number(item.DIAS);
            item.PAGO_TOTAL = Number(item.PAGO_TOTAL);
            item.CAPITAL = Number(item.CAPITAL);
            item.INTERES = Number(item.INTERES);
            item.SALDO_CAPITAL = Number(item.SALDO_CAPITAL);
            item.FACTOR = Number(item.FACTOR);
            item.PRODUCTO_ACUM = Number(item.PRODUCTO_ACUM);
            item.N_NOMINAL = Number(item.N_NOMINAL);
            item.PAGO_EXTRA = Number(item.PAGO_EXTRA)
          }

          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO = iterator.ENCCUOTA_CODIGO
          const datadet = this.cxctmpamortizacionService.dettmpamortiza.map(({
            CAPITAL, PLAZO, TASA, CUOTA_GRACIA, CUOTA_MENSUAL, DIAS, DIAS_GRACIA, FACTOR, FECHA,
            INTERES, NO_CUOTA, N_NOMINAL, OBSERVACION, PAGO_EXTRA, PAGO_TOTAL, PRODUCTO_ACUM, SALDO_CAPITAL,
            VAL_CUOTA, VAL_FINAN, DETCUO_LINEA, CIS, TRNCOBRO_NRODOC, ENCCUO_CODIGO,ENCCUOTA_CUOORIGEN,FACTURA_ANULAR
          }) => ({
            p_enccuota_codigo: iterator.ENCCUOTA_CODIGO,
            p_com_codigo: '01',
            p_detcuo_linea: DETCUO_LINEA,
            p_detcuo_fecha: FECHA,
            p_detcuo_version: 1,
            p_detcuo_vence: '',
            p_detcuo_nrocuota: NO_CUOTA,
            p_detcuo_dias: DIAS,
            p_detcuo_cuota: VAL_CUOTA,
            p_detcuo_pagoextra: PAGO_EXTRA,
            p_detcuo_pagototal: PAGO_TOTAL,
            p_detcuo_capital: CAPITAL,
            p_detcuo_interes: INTERES,
            p_detcuo_saldocapital: SALDO_CAPITAL,
            p_detcuo_observacion: OBSERVACION,
            p_detcuo_factor: FACTOR,
            p_detcuo_productoacum: PRODUCTO_ACUM,
            p_detcuo_n_nominal: N_NOMINAL,
            p_detcuo_int_mora: 0,
            p_detcuo_gastosfin: 0,
            p_detcuo_estado: '',
            p_TRNCOBRO_NRODOC: isNullOrUndefined(TRNCOBRO_NRODOC) ? '' : TRNCOBRO_NRODOC,
            p_ENCCUO_CODIGO: isNullOrUndefined(ENCCUO_CODIGO) || ENCCUO_CODIGO === '' ? iterator.ENCCUOTA_CODIGO : ENCCUO_CODIGO,
            p_ENCCUOTA_CUOORIGEN:isNullOrUndefined(ENCCUOTA_CUOORIGEN) || ENCCUOTA_CUOORIGEN === '' ? iterator.ENCCUOTA_CODIGO : ENCCUOTA_CUOORIGEN,
            p_FACTURA_ANULAR:isNullOrUndefined(FACTURA_ANULAR)?'':FACTURA_ANULAR
          }))
          await this.cxctmpamortizacionService.insertardetcuota(datadet);
          await this.auditoriagral.registrarAuditoria('VEN_DETCUOTA',
            'Código:' + iterator.ENCCUOTA_CODIGO + '/Factura:' + this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO, 'I',
            '', '01', '', '', '', '').toPromise();
          this.spin = false
          this.messageService.add({
            key: 'cxctmpamortiza',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al generar las cuotas'
          });
          await this.encontrarregistro(iterator.ENCCUOTA_CODIGO)
        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al generar las cuotas'
      });
      this.spin = false
      console.log(error)
    }
  }
  async generaramortizacion() {
    try {
      this.spin = true
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un factura'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un factura para que el campo cliente se llene correctamente'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo Tasa Anual no debe estar vacío'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo Plazo Original no debe estar vacío'
        });
        this.spin = false
        return
      }
      if (isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI) ||
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI === '') {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El campo Fecha no debe estar vacío'
        });
        this.spin = false
        return
      }
      if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI.toString().includes('-')) {
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI = this.datePipe.transform(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI, 'dd/MM/yyyy')
      }
      await this.cxctmpamortizacionService.ejecutarproceso(this.cxctmpamortizacionService.enctmpamortiza[this.indicador])
      const data = await this.cxctmpamortizacionService.consultartmpamortiza()

      if (isNullOrUndefined(data) === false && Object.keys(data).length > 0) {
        for (const iterator of data) {
          if (iterator.FECHA.toString().includes('-')) {
            iterator.FECHA = this.datePipe.transform(iterator.FECHA, 'dd/MM/yyyy')
          }
          iterator.CUOTA_MENSUAL = this.utilitariosService.formatear(iterator.CUOTA_MENSUAL, 2)
          iterator.CUOTA_GRACIA = this.utilitariosService.formatear(iterator.CUOTA_GRACIA, 2)
          iterator.VAL_CUOTA = this.utilitariosService.formatear(iterator.VAL_CUOTA, 2)
          iterator.PAGO_TOTAL = this.utilitariosService.formatear(iterator.PAGO_TOTAL, 2)
          iterator.CAPITAL = this.utilitariosService.formatear(iterator.CAPITAL, 2)
          iterator.INTERES = this.utilitariosService.formatear(iterator.INTERES, 2)
          iterator.SALDO_CAPITAL = this.utilitariosService.formatear(iterator.SALDO_CAPITAL, 2)
          iterator.DETCUO_LINEA = 0
          iterator.TRNCOBRO_NRODOC = '';
          iterator.ENCCUO_CODIGO = isNullOrUndefined(iterator.ENCCUO_CODIGO) ? '' : iterator.ENCCUO_CODIGO
          iterator.PAGO_EXTRA = this.utilitariosService.formatear(iterator.PAGO_EXTRA, 2)
          iterator.ENCCUOTA_CUOORIGEN=''
        }
        this.cxctmpamortizacionService.dettmpamortiza = data
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_MENSUAL = data[2].VAL_CUOTA
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_GRACIA = data[2].CUOTA_GRACIA
        this.spin = false
      } else {
        this.spin = false
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al generar la amortización'
      });
      this.spin = false
      console.log(error)
    }
  }
  cancelar() {
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.index = 0;
    document.getElementById('contorno').style.pointerEvents = 'none';
    if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO === ''
      || isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
    ) {
      this.lblclinombre = '';
      this.lblgarnombre = '';
      this.lblestado='';
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador] = {};
      this.cxctmpamortizacionService.dettmpamortiza = [];
      this.dettmpamortizaSelected = {}
    } else {
      this.encontrarregistro(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO)
    }
  }
  nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = false;
    this.lblclinombre = '';
    this.lblgarnombre = ''
    this.lblestado=''
    this.boolfac = false;
    this.cxctmpamortizacionService.enctmpamortiza[this.indicador] = {
      CAPITAL: '', CLI_CODIGO: '', COM_CODIGO: '01', CUOTA_MENSUAL: '',
      DIA_GRA: '', ENCFAC_NUMERO: '', FECINI: new Date(), PLAZO: '', TASA: '', ENCCUOTA_CODIGO: ''
      , GAR_ID: '', ASI_NRO: '', ENCCUOTA_CUOORIGEN: '', ENCCUO_ESTADO: ''
    }
    this.cxctmpamortizacionService.dettmpamortiza = [];
    this.dettmpamortizaSelected = {}
    document.getElementById('contorno').style.pointerEvents = 'all';
    setTimeout(() => {
      document.getElementById('ENCFAC_NUMERO').focus();
    }, 100);
  }
  changeTabs() {

  }

  botonesmodificar() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.btnRegresar = false;
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'ENCFAC_NUMERO': {
        this.busqueFactura(event.target.value)
        break;
      }
      case 'CAPITAL': {
        element = document.getElementById('TASA');
        break;
      }
      case 'TASA': {
        element = document.getElementById('PLAZO');
        break;
      }
      case 'PLAZO': {
        element = document.getElementById('DIA_GRA');
        break;
      }
      case 'GAR_ID': {
        this.busqueGarante(event.target.value)
        //element = document.getElementById('DIA_GRA');
        break;
      }
      default: {
        break;
      }
    }
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  busqueCliente(parametro) {

  }

  busqueFactura(parametro) {
    this.opcionbusqueda = 'docpend';
    this.types = [
      { label: 'TRNCOBRO_NRODOC', value: 'TRNCOBRO_NRODOC' },
      { label: 'DOCUMENTO', value: 'TRNCOBRO_NROCOMPROBANTE' },
      { label: 'COD.CLIENTE', value: 'CLI_CODIGO' },
      { label: 'NOMBRE CLIENTE', value: 'CLI_NOMBRE' },
      { label: 'IMPORTE', value: 'TRNCOBRO_IMPORTE' },
      { label: 'SALDO', value: 'SALDO' },
      { label: 'CONCEPTO', value: 'TRNCOBRO_CONCEPTO' },
      { label: 'TIPO', value: 'TRNCOBRO_TIPODOC' },
    ];
    this.busquedacampos = ['', '', '', '', '', '', '', ''];
    this.where = 'A.CLI_CODIGO = B.CLI_CODIGO AND VEN_FNC_SALDOFACTURA(A.COM_CODIGO,A.TRNCOBRO_NRODOC ) > 0 AND' +
      '  A.APLORG_CODIGO <> \'SISTEMA\' AND' +
      '   A.TRNCOBRO_TIPODOC IN(\'FC\',\'ND\')';
    this.tabla = 'CXC_TRNCOBRO A, VEN_MAECLIENTE B '//WHERE ' + condicion;
    this.consulta = 'A.TRNCOBRO_NRODOC,A.TRNCOBRO_NROCOMPROBANTE,A.CLI_CODIGO,B.CLI_NOMBRE,' +
      '  A.TRNCOBRO_IMPORTE, VEN_FNC_SALDOFACTURA(A.COM_CODIGO,A.TRNCOBRO_NRODOC ) AS SALDO,' +
      '  A.TRNCOBRO_CONCEPTO, A.TRNCOBRO_TIPODOC, B.CLI_TELEFONO1';
    let parametro2 = isNullOrUndefined(parametro) ? '' : parametro

    this.busquedaSer.busquedaCXCDocFacAmortiza(parametro2).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaCXCDocFacturasAmortiza(parametro).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {
              for (const iterator of res) {
                iterator.TRNCOBRO_IMPORTE = this.utilitariosService.formatear(iterator.TRNCOBRO_IMPORTE, 2)
                iterator.SALDO = this.utilitariosService.formatear(iterator.SALDO, 2)
              }
              this.arregloCons = res;
              this.displayDialogBusquedaFast = true;
            }

          });
        }
      } else {
        this.busquedaSer.busquedaCXCDocFacturasAmortiza(parametro).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {
            for (const iterator of res) {
              iterator.TRNCOBRO_IMPORTE = this.utilitariosService.formatear(iterator.TRNCOBRO_IMPORTE, 2)
              iterator.SALDO = this.utilitariosService.formatear(iterator.SALDO, 2)
            }
            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          }
        });
      }
    });

  }
  busqueGarante(parametro) {
    this.opcionbusqueda = 'BUSQUEDAGARANTE';
    this.types = [
      { label: 'RUC', value: 'GAR_ID' },
      { label: 'Nombre', value: 'GAR_NOMBRE' },
      // { label: 'RucIde', value: 'CLI_RUCIDE' },
      // { label: 'Zona', value: 'CLI_ZONA' },
      // { label: 'Grupo', value: 'GRU_CODIGO' },
      // { label: 'Contacto', value: 'CLI_CONTACTO' },
      // { label: 'Placa', value: 'CLI_PLACA' },
      // { label: 'NombreC', value: 'CLI_NOMBREC' },
    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'CXC_MAEGARANTE';
    this.where = ''
    this.consulta = '*'
    let parametro2 = isNullOrUndefined(parametro) ? '' : parametro

    this.busquedaSer.busquedaCxcMaeGaranteParam(parametro2).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaCxcGarante(parametro2).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {

              this.arregloCons = res;
              this.displayDialogBusquedaFast = true;
            }

          });
        }
      } else {
        this.busquedaSer.busquedaCxcGarante(parametro2).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {

            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          }
        });
      }
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'docpend') {

      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO = opcion.TRNCOBRO_NRODOC
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO = opcion.CLI_CODIGO
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CAPITAL = opcion.SALDO
      this.lblclinombre = opcion.CLI_NOMBRE
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_TELEFONO1 = opcion.CLI_TELEFONO1
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_MENSUAL = ''
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].DIA_GRA = ''
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO = ''
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA = ''
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_TIPO = opcion.TRNCOBRO_TIPODOC

      this.cxctmpamortizacionService.dettmpamortiza = [];
      document.getElementById('TASA').focus();
    }
    if (this.opcionbusqueda === 'BUSQUEDAENCCUOTA') {
      this.encontrarregistro(opcion.ENCCUO_CODIGO)
    }
    if (this.opcionbusqueda === 'BUSQUEDAGARANTE') {
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID = opcion.GAR_ID;
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_TELEFONO1 = opcion.GAR_TELEFONO1;
      this.lblgarnombre = opcion.GAR_NOMBRE;

    }
    this.displayDialogBusquedaFast = false;
  }
  async encontrarregistro(numero) {
    try {
      this.spin = true
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.index = 0;
      this.lblclinombre = '';
      this.lblgarnombre = '';
      this.lblestado='';
      this.spin = false
      this.cxctmpamortizacionService.enctmpamortiza[this.indicador] = {};
      this.cxctmpamortizacionService.dettmpamortiza = [];
      this.dettmpamortizaSelected = {}
      document.getElementById('contorno').style.pointerEvents = 'all';
      let numdoc = 0
      const data = await this.cxctmpamortizacionService.getenccuota(numero)
      if (data !== null && Object.keys(data).length > 0) {
        for (const iterator of data) {
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCFAC_NUMERO = iterator.ENCFAC_NUMERO;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO = iterator.ENCCUO_CODIGO;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_CODIGO = iterator.CLI_CODIGO;

          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CAPITAL = this.utilitariosService.formatear(iterator.ENCCUO_VALFINAN, 2);
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].TASA = this.utilitariosService.formatear(iterator.ENCCUO_TASA, 2);
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].PLAZO = Number(iterator.ENCCUO_PLAZO);
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].DIA_GRA = Number(iterator.ENCCUO_DIASGRACIA);
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].FECINI = new Date(iterator.ENCCUO_FECHA);
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID = isNullOrUndefined(iterator.GAR_ID) ? '' : iterator.GAR_ID;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ASI_NRO = isNullOrUndefined(iterator.ASI_NRO) ? '' : iterator.ASI_NRO;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_TIPO = isNullOrUndefined(iterator.ENCCUO_TIPO) ? '' : iterator.ENCCUO_TIPO;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CUOORIGEN = isNullOrUndefined(iterator.ENCCUOTA_CUOORIGEN) ? '' : iterator.ENCCUOTA_CUOORIGEN;
          this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO = isNullOrUndefined(iterator.ENCCUO_ESTADO) ? '' : iterator.ENCCUO_ESTADO;
          this.lblestado=this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO === 'D'?'DESACTIVADA':'ACTIVA';

          this.cxctmpamortizacionService.obtenerNombreCli(iterator.CLI_CODIGO).subscribe((res) => {
            this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CLI_TELEFONO1 = res[0].CLI_TELEFONO1;
          });
          this.busquedaSer.busquedaCxcMaeGaranteParam(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_ID).subscribe((eR: any[]) => {
            if (eR !== null) {
              if (Object.keys(eR).length === 1) {
                this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_TELEFONO1 = eR[0].GAR_TELEFONO1;
                this.lblgarnombre = eR[0].GAR_NOMBRE;
              } else {
                this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_TELEFONO1 = ''
              }
            } else {
              this.cxctmpamortizacionService.enctmpamortiza[this.indicador].GAR_TELEFONO1
            }
          })
          this.lblclinombre = iterator.CLI_NOMBRE

          const datadet = await this.cxctmpamortizacionService.getdetcuota(numero)
          if (datadet !== null && Object.keys(datadet).length > 0) {
            let dettmpamortiza: Cxcdettmpamortiza = {}
            for (const item of datadet) {
              if (item.DETCUO_FECHA.toString().includes('-')) {
                item.DETCUO_FECHA = this.datePipe.transform(item.DETCUO_FECHA, 'dd/MM/yyyy')
              }
              dettmpamortiza = {
                FECHA: item.DETCUO_FECHA,
                NO_CUOTA: item.DETCUO_NROCUOTA,
                DIAS: item.DETCUO_DIAS,
                VAL_CUOTA: this.utilitariosService.formatear(item.DETCUO_CUOTA, 2),
                PAGO_EXTRA: this.utilitariosService.formatear(item.DETCUO_PAGOEXTRA, 2),
                PAGO_TOTAL: this.utilitariosService.formatear(item.DETCUO_PAGOTOTAL, 2),
                CAPITAL: this.utilitariosService.formatear(item.DETCUO_CAPITAL, 2),
                INTERES: this.utilitariosService.formatear(item.DETCUO_INTERES, 2),
                SALDO_CAPITAL: this.utilitariosService.formatear(item.DETCUO_SALDOCAPITAL, 2),
                OBSERVACION: isNullOrUndefined(item.DETCUO_OBSERVACION) ? '' : item.DETCUO_OBSERVACION,
                FACTOR: item.DETCUO_FACTOR,
                PRODUCTO_ACUM: item.DETCUO_PRODUCTOACUM,
                N_NOMINAL: item.DETCUO_N_NOMINAL,
                DETCUO_LINEA: item.DETCUO_LINEA,
                ENCCUOTA_CODIGO: item.ENCCUOTA_CODIGO,
                TRNCOBRO_NRODOC: item.TRNCOBRO_NRODOC,
                CIS: isNullOrUndefined(item.CIS) ? '' : item.CIS,
                COM_CODIGO: item.COM_CODIGO,
                ENCCUO_CODIGO: isNullOrUndefined(item.ENCCUO_CODIGO) ? '' : item.ENCCUO_CODIGO
              }
              if (item.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(item.TRNCOBRO_NRODOC) === false) {
                numdoc++
              }
              this.cxctmpamortizacionService.dettmpamortiza.push(dettmpamortiza)
            }
            if (numdoc > 0) {
              document.getElementById('contorno').style.pointerEvents = 'none';
            }

            this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_MENSUAL = datadet[2].DETCUO_CUOTA
            this.aggrid.refreshaggrid(this.cxctmpamortizacionService.dettmpamortiza, this.defaultCxctmpamortiza.objeto)
          }
          this.boolfac = true;
          this.spin = false
        }
      } else {
        this.spin = false
      }

    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información de la amortización'
      });
      console.log(error)
      this.spin = false
      return
    }
  }
  seleccionItem(params) {

    if (params.object !== undefined) {
      this.dettmpamortizaSelected = params.object;
    }

  }
  cambio(evento) {

  }
  async abrirrefinaciamiento(params) {
    const data = await this.cxctmpamortizacionService.consultacis(params.TRNCOBRO_NRODOC)

    if (this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO !== ''
      && isNullOrUndefined(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO) === false
      && params.N_NOMINAL !== 0 && (params.CIS === '' || isNullOrUndefined(params.CIS))
      && this.utilitariosService.redondear(params.SALDO_CAPITAL, 2) > 0
      && params.TRNCOBRO_NRODOC !== '' && isNullOrUndefined(params.TRNCOBRO_NRODOC) === false
      && params.ENCCUO_CODIGO === this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO
      && this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUO_ESTADO !== 'D'
    ) {
      if (data !== null && Object.keys.length > 0) {
        for (const iterator of data) {
          if (iterator.CIS !== '' && isNullOrUndefined(iterator.CIS) === false) {
            this.messageService.add({
              key: 'cxctmpamortiza',
              severity: 'error',
              summary: 'Información',
              detail: 'El registro al que desea aplicar el refinanciamiento ya tiene registrado un CI, refresque la información por favor'
            });
            return;
          }
        }

      }
      this.abonocapital = Number(0).toFixed(2)
      this.displayrefi = true;
      setTimeout(() => {
        document.getElementById('abonocapital').focus();
      }, 100);

    }
  }
  manejarSenales2(valor) {
    if (valor === 'Salir') {
      this.displayrefi = false;
    }
  }
  async refinanciar() {
    try {
      if (this.utilitariosService.redondear(this.abonocapital, 2) > this.utilitariosService.redondear(this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CAPITAL, 2)) {
        this.messageService.add({
          key: 'cxctmpamortiza',
          severity: 'error',
          summary: 'Información',
          detail: 'El valor no puede ser mayor al valor financiado original'
        });
        return;
      }
      await this.cxctmpamortizacionService.aplicarefinacia(this.dettmpamortizaSelected, this.abonocapital);
      const data = await this.cxctmpamortizacionService.consultartmpamortiza()
      if (isNullOrUndefined(data) === false && Object.keys(data).length > 0) {
        this.cxctmpamortizacionService.dettmpamortiza = []
        for (const iterator of data) {
          if (iterator.FECHA.toString().includes('-')) {
            iterator.FECHA = this.datePipe.transform(iterator.FECHA, 'dd/MM/yyyy')
          }
          iterator.CUOTA_MENSUAL = this.utilitariosService.formatear(iterator.CUOTA_MENSUAL, 2)
          iterator.CUOTA_GRACIA = this.utilitariosService.formatear(iterator.CUOTA_GRACIA, 2)
          iterator.VAL_CUOTA = this.utilitariosService.formatear(iterator.VAL_CUOTA, 2)
          iterator.PAGO_TOTAL = this.utilitariosService.formatear(iterator.PAGO_TOTAL, 2)
          iterator.CAPITAL = this.utilitariosService.formatear(iterator.CAPITAL, 2)
          iterator.INTERES = this.utilitariosService.formatear(iterator.INTERES, 2)
          iterator.SALDO_CAPITAL = this.utilitariosService.formatear(iterator.SALDO_CAPITAL, 2)
          iterator.DETCUO_LINEA = 0
          iterator.TRNCOBRO_NRODOC = isNullOrUndefined(iterator.TRNCOBRO_NRODOC) ? '' : iterator.TRNCOBRO_NRODOC;
          iterator.CIS = isNullOrUndefined(iterator.CIS) ? '' : iterator.CIS;
          iterator.ENCCUO_CODIGO = isNullOrUndefined(iterator.ENCCUO_CODIGO) ? '' : iterator.ENCCUO_CODIGO
          iterator.PAGO_EXTRA = this.utilitariosService.formatear(iterator.PAGO_EXTRA, 2)
          iterator.ENCCUOTA_CUOORIGEN=isNullOrUndefined(iterator.ENCCUOTA_CUOORIGEN) ? '' : iterator.ENCCUOTA_CUOORIGEN;
          iterator.FACTURA_ANULAR=isNullOrUndefined(iterator.FACTURA_ANULAR)?'':iterator.FACTURA_ANULAR
        }
        this.btnNuevo = true;
        this.btnGuardar = false;
        this.btnBorrar = true;
        this.btnRegresar = false;
        this.cxctmpamortizacionService.dettmpamortiza = data
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_MENSUAL = data[2].VAL_CUOTA
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].CUOTA_GRACIA = data[2].CUOTA_GRACIA
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CODIGO = ''
        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ASI_NRO = ''
        this.lblestado='';

        this.cxctmpamortizacionService.enctmpamortiza[this.indicador].ENCCUOTA_CUOORIGEN = data[2].ENCCUOTA_CUOORIGEN
        this.spin = false
        this.displayrefi = false;
      } else {
        this.spin = false
        this.displayrefi = false;
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxctmpamortiza',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al aplicar el refinanciamiento'
      });
      console.log(error)
      this.displayrefi = false;
      this.spin = false;
      return;
    }


  }
}
